import { render, staticRenderFns } from "./WorkingArea.vue?vue&type=template&id=6ef42cd1&scoped=true"
import script from "./WorkingArea.vue?vue&type=script&lang=js"
export * from "./WorkingArea.vue?vue&type=script&lang=js"
import style0 from "./WorkingArea.vue?vue&type=style&index=0&id=6ef42cd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef42cd1",
  null
  
)

export default component.exports